import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';
import { useAuth0 } from '../providers/Auth0Provider';

const PrivateRoute = ({ component: Component, path, ...rest }) => {
  const { loading, isAuthenticated, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (loading || isAuthenticated) {
      return;
    }
    const fn = async () => {
      await loginWithRedirect({
        appState: { targetUrl: window.location.pathname },
      });
    };
    fn();
  }, [loading, isAuthenticated, loginWithRedirect, path]);

  // eslint-disable-next-line react/jsx-props-no-spreading
  const render = (props) =>
    isAuthenticated === true ? <Component {...props} /> : null;

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Route path={path} render={render} {...rest} />;
};

export default PrivateRoute;
